export const genres = [
  "热血",
  "校园",
  "恋爱",
  "科幻",
  "悬疑",
  "搞笑",
  "玄幻",
  "都市",
  "冒险",
  "运动",
  "治愈",
  "奇幻",
];

export const regions = ["中国", "日本", "韩国", "欧美"];

export const statuses = ["连载中", "已完结"];

export const sortOptions = [
  { key: "updated", label: "按更新时间" },
  { key: "popular", label: "按人气" },
  { key: "alpha", label: "按字母" },
];

export const comics = [
  {
    id: "xingyu-shaonian",
    title: "星域少年",
    cover: "https://readdy.ai/api/search-image?query=Modern%20anime%20manga%20cover%20art%2C%20young%20hero%20holding%20a%20glowing%20energy%20sword%20under%20a%20vast%20starry%20nebula%20sky%2C%20vibrant%20orange%20and%20deep%20navy%20palette%2C%20dynamic%20composition%2C%20clean%20simple%20gradient%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    author: "林野",
    genres: ["热血", "科幻", "冒险"],
    region: "中国",
    status: "连载中",
    description:
      "少年星瞳意外获得神秘星核，从此踏上穿越星域的冒险旅程。为了寻找失踪的兄长，他联手一群性格各异的伙伴，在浩瀚宇宙中对抗暗物质军团。热血的战斗、真挚的羁绊，一段关于成长与守护的星际物语就此展开。",
    updatedAt: "2026-10-12",
    views: 982340,
    chapters: [
      { id: "1", name: "第1话 坠落的星核", updatedAt: "2026-06-01" },
      { id: "2", name: "第2话 觉醒的代价", updatedAt: "2026-06-08" },
      { id: "3", name: "第3话 星港的少女", updatedAt: "2026-06-15" },
      { id: "4", name: "第4话 初次交锋", updatedAt: "2026-06-22" },
      { id: "5", name: "第5话 暗物质的低语", updatedAt: "2026-06-29" },
      { id: "6", name: "第6话 失控的力量", updatedAt: "2026-07-06" },
      { id: "7", name: "第7话 伙伴集结", updatedAt: "2026-07-13" },
      { id: "8", name: "第8话 陨石带伏击", updatedAt: "2026-07-20" },
      { id: "9", name: "第9话 星核共鸣", updatedAt: "2026-08-03" },
      { id: "10", name: "第10话 兄长留下的讯息", updatedAt: "2026-08-17" },
      { id: "11", name: "第11话 决意出发", updatedAt: "2026-09-07" },
      { id: "12", name: "第12话 深空之门", updatedAt: "2026-10-12" },
    ],
  },
  {
    id: "xiaoyuan-mitu",
    title: "校园迷途",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%2C%20quiet%20high%20school%20corridor%20with%20a%20lone%20student%20silhouette%20and%20long%20afternoon%20shadows%2C%20muted%20amber%20and%20slate%20blue%20tones%2C%20mysterious%20atmosphere%2C%20simple%20clean%20background%2C%20high%20detail%2C%20editorial%20art&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    author: "顾清",
    genres: ["校园", "悬疑"],
    region: "中国",
    status: "连载中",
    description:
      "转学生夏言发现，这所看似平静的高中藏着一个被所有人遗忘的旧教室。每当午夜钟声响起，走廊尽头就会传来低语。解开谜题的关键，或许就藏在那些被撕掉的校刊里。",
    updatedAt: "2026-10-10",
    views: 645210,
    chapters: [
      { id: "1", name: "第1话 转学生的第一天", updatedAt: "2026-07-02" },
      { id: "2", name: "第2话 封存的旧教室", updatedAt: "2026-07-09" },
      { id: "3", name: "第3话 午夜的低语", updatedAt: "2026-07-16" },
      { id: "4", name: "第4话 缺失的校刊", updatedAt: "2026-07-23" },
      { id: "5", name: "第5话 同桌的秘密", updatedAt: "2026-08-06" },
      { id: "6", name: "第6话 天台的对峙", updatedAt: "2026-08-20" },
      { id: "7", name: "第7话 被遗忘的名字", updatedAt: "2026-09-10" },
      { id: "8", name: "第8话 真相的一角", updatedAt: "2026-10-10" },
    ],
  },
  {
    id: "xindong-xinhao",
    title: "心动信号",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20anime%20manga%20cover%2C%20two%20high%20school%20students%20sharing%20earphones%20under%20warm%20sunset%20light%20with%20floating%20petals%2C%20soft%20peach%20and%20cream%20pastel%20palette%2C%20tender%20warm%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    author: "苏晚棠",
    genres: ["恋爱", "治愈", "校园"],
    region: "日本",
    status: "连载中",
    description:
      "广播社的深夜节目里，总有一个匿名听众会点同一首歌。当主播放苏澄循着线索找到那个人的时候，才发现对方一直在离自己最近的地方。一场由声音牵起的青春恋爱物语，温柔又令人心动。",
    updatedAt: "2026-10-09",
    views: 812450,
    chapters: [
      { id: "1", name: "第1话 深夜电台", updatedAt: "2026-06-12" },
      { id: "2", name: "第2话 匿名点歌", updatedAt: "2026-06-19" },
      { id: "3", name: "第3话 雨中的伞", updatedAt: "2026-06-26" },
      { id: "4", name: "第4话 同一首歌", updatedAt: "2026-07-10" },
      { id: "5", name: "第5话 越走越近", updatedAt: "2026-07-24" },
      { id: "6", name: "第6话 试探的心意", updatedAt: "2026-08-14" },
      { id: "7", name: "第7话 天台告白", updatedAt: "2026-09-04" },
      { id: "8", name: "第8话 原来是你", updatedAt: "2026-09-25" },
      { id: "9", name: "第9话 并肩的夏天", updatedAt: "2026-10-09" },
    ],
  },
  {
    id: "anye-zhentan",
    title: "暗夜侦探",
    cover: "https://readdy.ai/api/search-image?query=Noir%20detective%20anime%20manga%20cover%2C%20stylish%20sleuth%20in%20long%20coat%20under%20rainy%20neon%20city%20street%20at%20night%2C%20moody%20amber%20and%20charcoal%20palette%2C%20dramatic%20lighting%2C%20simple%20clean%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    author: "程野",
    genres: ["悬疑", "都市", "热血"],
    region: "韩国",
    status: "已完结",
    description:
      "私家侦探陆沉接手的每一桩委托，背后似乎都连着同一个组织。当他逐步逼近真相，才发现自己记忆深处那段空白，正是整个谜团的起点。冷硬派都市悬疑，逻辑缜密，反转不断。",
    updatedAt: "2026-09-28",
    views: 733120,
    chapters: [
      { id: "1", name: "第1话 雨夜的委托", updatedAt: "2026-03-03" },
      { id: "2", name: "第2话 消失的证人", updatedAt: "2026-03-17" },
      { id: "3", name: "第3话 老城区谜案", updatedAt: "2026-04-07" },
      { id: "4", name: "第4话 记忆的空白", updatedAt: "2026-04-28" },
      { id: "5", name: "第5话 双面档案", updatedAt: "2026-05-19" },
      { id: "6", name: "第6话 真凶现身", updatedAt: "2026-06-16" },
      { id: "7", name: "第7话 最后的布局", updatedAt: "2026-08-11" },
      { id: "8", name: "第8话 尘埃落定", updatedAt: "2026-09-28" },
    ],
  },
  {
    id: "jianqi-canglan",
    title: "剑起苍澜",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20wuxia%20manga%20cover%2C%20young%20swordmaster%20surrounded%20by%20swirling%20ink%20clouds%20and%20glowing%20rune%20power%2C%20jade%20green%20and%20warm%20orange%20accent%20palette%2C%20epic%20dynamic%20pose%2C%20clean%20simple%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    author: "墨长歌",
    genres: ["玄幻", "热血", "冒险"],
    region: "中国",
    status: "连载中",
    description:
      "苍澜大陆灵气复苏，少年叶无双自山野小镇而出，一把锈剑走天下。他要问的不仅是武道之巅，更是那句被尘封了千年的天道之问。东方奇幻长篇，格局宏阔。",
    updatedAt: "2026-10-13",
    views: 1125600,
    chapters: [
      { id: "1", name: "第1话 山野少年", updatedAt: "2026-05-05" },
      { id: "2", name: "第2话 锈剑入手", updatedAt: "2026-05-12" },
      { id: "3", name: "第3话 初入宗门", updatedAt: "2026-05-19" },
      { id: "4", name: "第4话 灵根之争", updatedAt: "2026-05-26" },
      { id: "5", name: "第5话 试炼秘境", updatedAt: "2026-06-09" },
      { id: "6", name: "第6话 一剑破阵", updatedAt: "2026-06-23" },
      { id: "7", name: "第7话 天道之问", updatedAt: "2026-07-14" },
      { id: "8", name: "第8话 苍澜之巅", updatedAt: "2026-08-18" },
      { id: "9", name: "第9话 无双之名", updatedAt: "2026-09-22" },
      { id: "10", name: "第10话 剑指苍穹", updatedAt: "2026-10-13" },
    ],
  },
  {
    id: "saibo-liming",
    title: "赛博黎明",
    cover: "https://readdy.ai/api/search-image?query=Cyberpunk%20anime%20manga%20cover%2C%20female%20hacker%20with%20glowing%20augmented%20arm%20in%20futuristic%20city%20of%20holograms%2C%20teal%20and%20amber%20neon%20palette%2C%20high%20tech%20dynamic%20composition%2C%20simple%20clean%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    author: "夜航",
    genres: ["科幻", "都市", "悬疑"],
    region: "欧美",
    status: "连载中",
    description:
      "在霓虹与数据构筑的巨型都市里，黑客零号发现自己的记忆被反复改写过。为了找回真实的自己，她必须潜入这座城市最深的数据库。赛博朋克风冒险，脑洞大开。",
    updatedAt: "2026-10-08",
    views: 587900,
    chapters: [
      { id: "1", name: "第1话 数据之城的清晨", updatedAt: "2026-06-05" },
      { id: "2", name: "第2话 被改写的记忆", updatedAt: "2026-06-20" },
      { id: "3", name: "第3话 潜入底层", updatedAt: "2026-07-05" },
      { id: "4", name: "第4话 义体的秘密", updatedAt: "2026-07-26" },
      { id: "5", name: "第5话 三重身份", updatedAt: "2026-08-16" },
      { id: "6", name: "第6话 黎明之前", updatedAt: "2026-09-06" },
      { id: "7", name: "第7话 核心协议", updatedAt: "2026-10-08" },
    ],
  },
  {
    id: "lanqiu-zhilu",
    title: "篮球之路",
    cover: "https://readdy.ai/api/search-image?query=Sports%20anime%20manga%20cover%2C%20determined%20teenage%20basketball%20player%20dunking%20under%20bright%20gym%20lights%2C%20energetic%20orange%20and%20white%20palette%2C%20motion%20blur%20dynamic%20pose%2C%20simple%20clean%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    author: "周燃",
    genres: ["运动", "热血", "校园"],
    region: "中国",
    status: "连载中",
    description:
      "身高不足的替补控卫高飞，用速度和意志叩响全国大赛的大门。汗水、失败、再站起，这是一群少年为了一个篮筐倾尽全力的青春故事。燃到最后一秒。",
    updatedAt: "2026-10-11",
    views: 498760,
    chapters: [
      { id: "1", name: "第1话 永远的替补", updatedAt: "2026-06-03" },
      { id: "2", name: "第2话 三分钟奇迹", updatedAt: "2026-06-17" },
      { id: "3", name: "第3话 首发之争", updatedAt: "2026-07-01" },
      { id: "4", name: "第4话 县大赛首秀", updatedAt: "2026-07-22" },
      { id: "5", name: "第5话 宿敌重逢", updatedAt: "2026-08-12" },
      { id: "6", name: "第6话 落后二十分", updatedAt: "2026-09-02" },
      { id: "7", name: "第7话 绝杀时刻", updatedAt: "2026-10-11" },
    ],
  },
  {
    id: "bianlidian-richang",
    title: "便利店日常",
    cover: "https://readdy.ai/api/search-image?query=Slice%20of%20life%20comedy%20anime%20manga%20cover%2C%20cozy%20late%20night%20convenience%20store%20with%20friendly%20clerk%20and%20warm%20glow%2C%20soft%20cream%20and%20tangerine%20palette%2C%20cheerful%20relaxed%20mood%2C%20simple%20clean%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    author: "小柚",
    genres: ["搞笑", "治愈", "都市"],
    region: "日本",
    status: "已完结",
    description:
      "凌晨三点的便利店，是这座城市最温柔的小小避风港。上班族、夜归的学生、失眠的作家……每个人都在这里留下一个故事。轻松治愈的单元小剧场。",
    updatedAt: "2026-09-20",
    views: 356400,
    chapters: [
      { id: "1", name: "第1话 深夜的关东煮", updatedAt: "2026-02-08" },
      { id: "2", name: "第2话 忘记带钱包的客人", updatedAt: "2026-02-22" },
      { id: "3", name: "第3话 招财猫的烦恼", updatedAt: "2026-03-15" },
      { id: "4", name: "第4话 最后一盒牛奶", updatedAt: "2026-04-12" },
      { id: "5", name: "第5话 换班的秘密", updatedAt: "2026-05-24" },
      { id: "6", name: "第6话 不打烊的灯", updatedAt: "2026-09-20" },
    ],
  },
  {
    id: "dushi-yixian",
    title: "都市医仙",
    cover: "https://readdy.ai/api/search-image?query=Urban%20fantasy%20manga%20cover%2C%20calm%20young%20doctor%20in%20white%20coat%20with%20glowing%20herbal%20energy%20swirling%20around%20his%20hand%2C%20emerald%20and%20warm%20gold%20palette%2C%20confident%20pose%2C%20clean%20simple%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    author: "云中鹤",
    genres: ["都市", "玄幻", "治愈"],
    region: "中国",
    status: "连载中",
    description:
      "落魄中医传人陈默偶得上古医经，一身医术出神入化。大医院的激烈竞争、疑难杂症的挑战、还有藏在都市暗处的旧日恩仇，都等着他一一化解。轻松爽文风。",
    updatedAt: "2026-10-14",
    views: 921300,
    chapters: [
      { id: "1", name: "第1话 街头小诊所", updatedAt: "2026-05-02" },
      { id: "2", name: "第2话 上古医经", updatedAt: "2026-05-16" },
      { id: "3", name: "第3话 一针救人", updatedAt: "2026-05-30" },
      { id: "4", name: "第4话 大医院风波", updatedAt: "2026-06-20" },
      { id: "5", name: "第5话 疑难会诊", updatedAt: "2026-07-11" },
      { id: "6", name: "第6话 旧日恩仇", updatedAt: "2026-08-08" },
      { id: "7", name: "第7话 医者仁心", updatedAt: "2026-09-12" },
      { id: "8", name: "第8话 妙手回春", updatedAt: "2026-10-14" },
    ],
  },
  {
    id: "yishijie-shitang",
    title: "异世界食堂",
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20food%20manga%20cover%2C%20warm%20cozy%20tavern%20kitchen%20with%20steaming%20dishes%20and%20magical%20floating%20ingredients%2C%20honey%20amber%20and%20forest%20green%20palette%2C%20welcoming%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    author: "食梦",
    genres: ["奇幻", "搞笑", "治愈"],
    region: "日本",
    status: "连载中",
    description:
      "每周六，这家小食堂都会迎来一批特别的客人——精灵、骑士、龙族。他们只为一口人间烟火而来。美食与奇幻交织的温情剧场，看得人饥肠辘辘。",
    updatedAt: "2026-10-07",
    views: 412800,
    chapters: [
      { id: "1", name: "第1话 精灵的第一碗面", updatedAt: "2026-06-10" },
      { id: "2", name: "第2话 龙族的甜品挑战", updatedAt: "2026-06-24" },
      { id: "3", name: "第3话 骑士的乡愁", updatedAt: "2026-07-15" },
      { id: "4", name: "第4话 神秘的新客人", updatedAt: "2026-08-05" },
      { id: "5", name: "第5话 招牌菜的秘密", updatedAt: "2026-09-09" },
      { id: "6", name: "第6话 周六再相聚", updatedAt: "2026-10-07" },
    ],
  },
  {
    id: "shenhai-huixiang",
    title: "深海回响",
    cover: "https://readdy.ai/api/search-image?query=Deep%20sea%20adventure%20manga%20cover%2C%20diver%20exploring%20bioluminescent%20underwater%20ruins%20with%20mysterious%20light%2C%20deep%20indigo%20and%20aqua%20teal%20palette%2C%20eerie%20wonder%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    author: "深海岳",
    genres: ["冒险", "悬疑", "科幻"],
    region: "欧美",
    status: "连载中",
    description:
      "海洋学家江涛在国际海域发现了一处会发出规律声响的古代遗迹。随着下潜的深入，一个关于失落文明与海洋意志的惊天秘密逐渐浮出水面。紧张刺激的深海冒险。",
    updatedAt: "2026-10-06",
    views: 334900,
    chapters: [
      { id: "1", name: "第1话 深海的电波", updatedAt: "2026-07-04" },
      { id: "2", name: "第2话 沉没的遗迹", updatedAt: "2026-07-25" },
      { id: "3", name: "第3话 发光的壁画", updatedAt: "2026-08-15" },
      { id: "4", name: "第4话 深潜危机", updatedAt: "2026-09-05" },
      { id: "5", name: "第5话 失落的文明", updatedAt: "2026-10-06" },
    ],
  },
  {
    id: "tianxin-hongbei",
    title: "甜心烘焙屋",
    cover: "https://readdy.ai/api/search-image?query=Romance%20bakery%20anime%20manga%20cover%2C%20cheerful%20girl%20pastry%20chef%20surrounded%20by%20colorful%20cakes%20and%20soft%20sunlight%2C%20strawberry%20pink%20and%20cream%20palette%2C%20sweet%20joyful%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    author: "糖霜",
    genres: ["恋爱", "治愈", "都市"],
    region: "韩国",
    status: "已完结",
    description:
      "为了挽救外婆留下的小烘焙屋，甜品师安安请来了性格冷淡的天才糕点师协助。一个固执、一个毒舌，却在一次次揉面与烘烤中，慢慢烤出了心动的味道。",
    updatedAt: "2026-09-18",
    views: 389200,
    chapters: [
      { id: "1", name: "第1话 濒临倒闭的店", updatedAt: "2026-03-01" },
      { id: "2", name: "第2话 毒舌糕点师", updatedAt: "2026-03-15" },
      { id: "3", name: "第3话 第一次合作", updatedAt: "2026-04-05" },
      { id: "4", name: "第4话 客人回来了", updatedAt: "2026-05-10" },
      { id: "5", name: "第5话 烤箱里的心意", updatedAt: "2026-06-21" },
      { id: "6", name: "第6话 招牌回归", updatedAt: "2026-09-18" },
    ],
  },
  {
    id: "moshi-jiyuan",
    title: "末世纪元",
    cover: "https://readdy.ai/api/search-image?query=Post%20apocalyptic%20manga%20cover%2C%20lone%20survivor%20on%20a%20ruined%20highway%20with%20overgrown%20city%20skyline%20behind%2C%20dusty%20rust%20orange%20and%20gray%20palette%2C%20determined%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-13&orientation=portrait",
    author: "荒原",
    genres: ["科幻", "冒险", "悬疑"],
    region: "欧美",
    status: "连载中",
    description:
      "灾变三十年后，人类在废墟中艰难求生。少年雷恩带着一台神秘的老式收音机，循着断续的信号，踏上寻找最后绿洲的旅程。末世氛围拉满的硬核冒险。",
    updatedAt: "2026-10-05",
    views: 445700,
    chapters: [
      { id: "1", name: "第1话 废墟之上", updatedAt: "2026-06-02" },
      { id: "2", name: "第2话 断断续续的信号", updatedAt: "2026-06-23" },
      { id: "3", name: "第3话 掠夺者", updatedAt: "2026-07-21" },
      { id: "4", name: "第4话 绿洲的传闻", updatedAt: "2026-08-25" },
      { id: "5", name: "第5话 最后的电台", updatedAt: "2026-10-05" },
    ],
  },
  {
    id: "jianghu-yeyu",
    title: "江湖夜雨",
    cover: "https://readdy.ai/api/search-image?query=Wuxia%20period%20manga%20cover%2C%20wandering%20swordsman%20in%20a%20rainy%20ancient%20town%20with%20red%20lanterns%2C%20deep%20crimson%20and%20ink%20black%20palette%2C%20melancholic%20heroic%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-14&orientation=portrait",
    author: "归鸿",
    genres: ["玄幻", "热血", "都市"],
    region: "中国",
    status: "连载中",
    description:
      "江湖传言，得「夜雨剑」者得天下。漂泊剑客沈砚却只想查明师父的死因。刀光剑影背后，是一段被恩怨掩埋了二十年的旧情与背叛。",
    updatedAt: "2026-10-04",
    views: 501600,
    chapters: [
      { id: "1", name: "第1话 夜雨孤客", updatedAt: "2026-05-08" },
      { id: "2", name: "第2话 客栈风波", updatedAt: "2026-05-29" },
      { id: "3", name: "第3话 旧仇新怨", updatedAt: "2026-06-26" },
      { id: "4", name: "第4话 二十年前", updatedAt: "2026-07-31" },
      { id: "5", name: "第5话 剑指故人", updatedAt: "2026-09-11" },
      { id: "6", name: "第6话 雨歇天青", updatedAt: "2026-10-04" },
    ],
  },
  {
    id: "ouxiang-lianxisheng",
    title: "偶像练习生",
    cover: "https://readdy.ai/api/search-image?query=Idol%20school%20anime%20manga%20cover%2C%20cheerful%20trainee%20on%20a%20bright%20stage%20with%20spotlights%20and%20confetti%2C%20vivid%20magenta%20and%20gold%20palette%2C%20energetic%20dreamy%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-15&orientation=portrait",
    author: "星野澈",
    genres: ["校园", "恋爱", "搞笑"],
    region: "韩国",
    status: "连载中",
    description:
      "为了梦想，普通女孩林小满误打误撞进入练习生选拔。唱跳全废的她要如何在这个残酷的舞台生存下去？高甜高燃的偶像成长故事，笑点与泪点齐飞。",
    updatedAt: "2026-10-03",
    views: 376500,
    chapters: [
      { id: "1", name: "第1话 意外入选", updatedAt: "2026-06-07" },
      { id: "2", name: "第2话 地狱训练", updatedAt: "2026-06-28" },
      { id: "3", name: "第3话 组队舞台", updatedAt: "2026-07-26" },
      { id: "4", name: "第4话 人气投票", updatedAt: "2026-08-23" },
      { id: "5", name: "第5话 C位之争", updatedAt: "2026-09-27" },
      { id: "6", name: "第6话 闪耀之夜", updatedAt: "2026-10-03" },
    ],
  },
  {
    id: "jixie-zhixin",
    title: "机械之心",
    cover: "https://readdy.ai/api/search-image?query=Mecha%20anime%20manga%20cover%2C%20pilot%20boy%20standing%20before%20a%20giant%20humanoid%20robot%20in%20a%20hangar%2C%20steel%20silver%20and%20warm%20orange%20accent%20palette%2C%20heroic%20dynamic%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-16&orientation=portrait",
    author: "铁翼",
    genres: ["科幻", "热血", "冒险"],
    region: "日本",
    status: "连载中",
    description:
      "在人类与机械生命共存的未来，机师天野驾驶着祖传机甲「赤心」，守护着两族脆弱的和平。当战争的阴影再度降临，他必须做出改变历史的选择。",
    updatedAt: "2026-10-02",
    views: 467800,
    chapters: [
      { id: "1", name: "第1话 沉睡的机甲", updatedAt: "2026-06-13" },
      { id: "2", name: "第2话 初阵", updatedAt: "2026-07-04" },
      { id: "3", name: "第3话 两族的裂痕", updatedAt: "2026-08-01" },
      { id: "4", name: "第4话 赤心觉醒", updatedAt: "2026-08-29" },
      { id: "5", name: "第5话 战火重燃", updatedAt: "2026-09-26" },
      { id: "6", name: "第6话 守护的意义", updatedAt: "2026-10-02" },
    ],
  },
  {
    id: "linghu-chuanshuo",
    title: "灵狐传说",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20ling%20fox%20spirit%20manga%20cover%2C%20elegant%20nine%20tailed%20fox%20girl%20in%20flowing%20ancient%20robes%20with%20falling%20peach%20blossoms%2C%20soft%20coral%20and%20jade%20palette%2C%20ethereal%20graceful%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-17&orientation=portrait",
    author: "青丘月",
    genres: ["奇幻", "玄幻", "恋爱"],
    region: "中国",
    status: "连载中",
    description:
      "修炼千年的灵狐白锦，为了报恩而下山寻找转世恩人。然而人间早已物是人非，她要面对的，是一段跨越生死与族群的宿命情缘。唯美国风奇幻。",
    updatedAt: "2026-10-01",
    views: 429100,
    chapters: [
      { id: "1", name: "第1话 千年修行", updatedAt: "2026-06-06" },
      { id: "2", name: "第2话 下山寻恩", updatedAt: "2026-06-27" },
      { id: "3", name: "第3话 转世之人", updatedAt: "2026-07-18" },
      { id: "4", name: "第4话 人妖之隔", updatedAt: "2026-08-22" },
      { id: "5", name: "第5话 宿命重逢", updatedAt: "2026-09-19" },
      { id: "6", name: "第6话 白锦的选择", updatedAt: "2026-10-01" },
    ],
  },
  {
    id: "nixi-xueba",
    title: "逆袭学霸",
    cover: "https://readdy.ai/api/search-image?query=School%20comedy%20anime%20manga%20cover%2C%20confident%20student%20holding%20books%20in%20a%20bright%20classroom%20with%20chalkboard%2C%20fresh%20mint%20and%20warm%20orange%20palette%2C%20upbeat%20motivated%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20editorial%20illustration&width=400&height=560&seq=comic-cover-18&orientation=portrait",
    author: "逆风",
    genres: ["校园", "都市", "搞笑"],
    region: "中国",
    status: "连载中",
    description:
      "常年垫底的学渣程一鸣，在一次意外后获得了过目不忘的能力。从教室最后一排到年级榜首，他要证明的，从来都不只是成绩。轻松励志的校园成长喜剧。",
    updatedAt: "2026-09-30",
    views: 298400,
    chapters: [
      { id: "1", name: "第1话 倒数第一名", updatedAt: "2026-06-16" },
      { id: "2", name: "第2话 意外觉醒", updatedAt: "2026-07-07" },
      { id: "3", name: "第3话 第一次及格", updatedAt: "2026-07-28" },
      { id: "4", name: "第4话 月考风云", updatedAt: "2026-08-25" },
      { id: "5", name: "第5话 年级第一", updatedAt: "2026-09-30" },
    ],
  },
];